import { z } from 'zod';

export const companyInformationSchema = z.object({
  hasGroupName: z.string(),
  groupName: z.string(),
  activitySectorId: z.number().nullish(),
});
